module.exports = __webpack_public_path__ + "static/media/Report.f004bdeb.png";